import ReactDOM from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux';
import { firstValueFrom } from 'rxjs';

import App from './App';
import { ThemeProvider } from 'hooks';
import { store } from 'redux/root.store';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import { LocalizerProvider, makeGet } from 'services';
import { configureThumbnailToken, ThumbnailToken } from 'components/partials/thumbnail/token-store';

declare global {
  interface Navigator {
    standalone?: boolean;
  }

  interface Window {
    pdfjsLib?: any;
  }
}

configureThumbnailToken(() => firstValueFrom(makeGet('images/thumbnail-token')).then(({ response }) => response as ThumbnailToken));

// Disable multi-touch zoom gestures (e.g. pinch-to-zoom) globally,
// as users were unintentionally zooming into the app during damage labelling.
document.addEventListener('touchmove', (e) => {
  if (e.touches.length > 1) e.preventDefault();
}, { passive: false });

ReactDOM.render(
  <ReduxProvider store={store}>
    <ThemeProvider>
      <LocalizerProvider>
        <App />
      </LocalizerProvider>
    </ThemeProvider>
  </ReduxProvider>,
  document.getElementById('appRoot')
);
reportWebVitals();
serviceWorker.unregister();
